import { render, staticRenderFns } from "./StudentAbsenceNumberOfDaysTable.vue?vue&type=template&id=90988022&"
import script from "./StudentAbsenceNumberOfDaysTable.vue?vue&type=script&lang=js&"
export * from "./StudentAbsenceNumberOfDaysTable.vue?vue&type=script&lang=js&"
import style0 from "./StudentAbsenceNumberOfDaysTable.vue?vue&type=style&index=0&id=90988022&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports